//Library Imports
import { ReactComponent as CrossIcon } from "../../../../assets/img/icons/cross.svg";
import React, { useState } from "react";
import { connect } from "react-redux";
import Reaptcha from "reaptcha";

// application components goes here
import GlobalStyle from "../../../../GlobalStyle";
import Button from "../../../Common/Components/Button";
import Input from "../../../Common/Components/Input";
import Message from "../../../Common/Components/Message";
import { formatLoginData, validateEmailField } from "../../Utils";
import { getResetPasswordService } from "../../action";
import { CAPTCHA_SITE_KEY } from "../../../../constants/index";

// styles goes here
import styled from "styled-components";
import { IErrorsState } from "../Interfaces";

type ForgotPasswordProps = { setRedirectPath: (val: string) => void };

const ForgotPassword: React.FC<ForgotPasswordProps> = (props: ForgotPasswordProps) => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState({
    status: true,
    message: "",
  });
  const [captcha, setCaptcha] = useState("");
  const [captchaStatus, setCaptchaStatus] = useState(1);
  const [captchaValue, setcaptchaValue] = useState("");
  const [loading, setLoading] = useState(false);

  //Errors
  const [errors, setErrors] = useState<IErrorsState>();

  // Captcha verification
  const onVerify = (recaptchaResponse: string) => {
    setCaptcha("");
    setcaptchaValue(recaptchaResponse);
  };

  //validates email address and calls service
  function handlePasswordReset() {
    const validationMessage = validateEmailField(captchaValue, email);
    if (!validationMessage.status) {
      setMessage(validationMessage);
      setErrors(validationMessage.errors);
    } else {
      callPasswordResetAPI(formatLoginData(email, captchaValue, false));
      setMessage({ status: true, message: "" });
    }
  }

  // calls password reset service
  function callPasswordResetAPI(formData: FormData) {
    setLoading(true);
    getResetPasswordService(formData).then((response) => {
      console.log(response);
      if (response.status === 200) {
        props.setRedirectPath("resetPassword");
      } else {
        setMessage({ status: false, message: "Something went wrong" });
      }
      setLoading(false);
    });
  }

  return (
    <>
      <GlobalStyle />
      <LoginWrapper>
        <span className="cross-btn" onClick={(e) => props.setRedirectPath("")}>
          <CrossIcon />
        </span>
        <div className="content-wrapper">
          <h2>Forgot Password</h2>
          {!message.status ? <Message type="error" label="Error!" message={message.message} /> : ""}
          <p>
            Please enter the email address you use to log into Workbench. If we find a match, we’ll send a password
            reset link to that email.
          </p>
        </div>
        <div className="input-field-spacing">
          <Input
            name="email"
            error={errors?.email}
            label="Workbench account email"
            type="text"
            placeholder="Enter your email address…"
            onChange={(e: React.FormEvent<HTMLInputElement>) => {
              setEmail(e.currentTarget.value);
              if (errors?.email) {
                setErrors({});
                setMessage({ ...message, status: true });
              }
            }}
          />
        </div>

        <Button
          disabled={loading}
          value={loading ? "Loading..." : "Reset Password Now"}
          onClick={handlePasswordReset}
        />
        {captchaStatus ? (
          <div className="mt-3">
            <div className="col-12 mb-1 pl-0 mt-2">
              <Reaptcha sitekey={CAPTCHA_SITE_KEY} onVerify={onVerify} />
            </div>
            {captcha && (
              <div className="col-12 mt-2 p-0">
                <div className="text-danger">{captcha}</div>
              </div>
            )}
          </div>
        ) : null}
        <p>
          Just forgot your
          <span className="span me-0" onClick={(e) => props.setRedirectPath("username")}>
            username
          </span>
          ?
        </p>
      </LoginWrapper>
    </>
  );
};

export default connect()(ForgotPassword);

const LoginWrapper = styled.div`
  margin: 0px;
  padding: 25px 60px 15px 60px;
  border-radius: 30px;
  background-color: #fff;
  display: block;
  width: 100%;
  position: relative;
  @media all and (max-width: 1439px), all and (max-height: 749px) {
    padding: 0px 40px 20px 40px;
    border-radius: 21px;
    max-width: 400px;
  }
  .cross-btn {
    position: absolute;
    right: 18px;
    top: 20px;
    cursor: pointer;
    @media all and (max-width: 1439px), all and (max-height: 749px) {
      top: 12px;
      svg {
        width: 23px;
        height: 23px;
      }
    }
  }
  .content-wrapper {
    margin-top: 0px;
    margin-bottom: 0px;
    h2 {
      margin-top: 20px;
    }
  }
  .input-field-spacing {
    margin-top: 30px;
    margin-bottom: 25px;
    /* margin-top: 50px;
    margin-bottom: 60px;
    @media all and (max-width: 1439px), all and (max-height: 749px) {
      margin-top: 30px;
      margin-bottom: 25px;
    } */
  }
  h2 {
    color: #424b50;
    font-size: 32px;
    margin: 35px 0 10px 0;
    font-weight: bold;
    text-align: left;
    @media all and (max-width: 1439px), all and (max-height: 749px) {
      font-size: 22px;
    }
  }

  p {
    font-size: 16px;
    color: #5e7079;
    margin: 15px 0;
    font-family: "robotobold";
    @media all and (max-width: 1439px), all and (max-height: 749px) {
      font-size: 12px;
      margin: 15px 0 0 0;
    }
    .span {
      cursor: pointer;
      margin: 0 5px;
      color: #27ce0a !important;
      font-weight: 700;
      text-decoration: none;
    }
  }
  input[type="text"],
  input[type="password"] {
    @media all and (max-width: 1439px), all and (max-height: 749px) {
      font-size: 16px;
      line-height: 20px;
      padding: 8px 18px;
      &.password + span {
        top: 13px;
      }
    }
  }
  label {
    @media all and (max-width: 1439px), all and (max-height: 749px) {
      margin: 16px 0 5px 0;
      font-size: 12px;
    }
  }
  button {
    @media all and (max-width: 1439px), all and (max-height: 749px) {
      font-size: 16px;
      padding: 9px 18px;
    }
  }
  .g-recaptcha > div {
    height: 85px !important;
    div > iframe {
      height: 85px !important;
    }
  }
`;
